<template>
    <div class="items-center overlay-background container py-8">
        <!-- eslint-disable vue/no-bare-strings-in-template -->
        <img
            src="/images/decorations/melting-smile-orange.svg"
            class="md:block hidden mt-[-145px] mx-auto mb-4"
            alt="Melting smiley"
        />
        <div class="flex flex-col items-center text-center text-white">
            <h2 class="leading-7 font-works-sans md:leading-11 mb-3 md:mb-2">
                {{ $t('show.guest.h1') }}
            </h2>

            <span class="md:block hidden mb-5 md:text-lg leading-6 md:leading-8">
                <span>{{ $t('show.guest.text') }}</span>
            </span>

            <!-- native modifier has been removed, please confirm whether the function has been affected  -->

            <BtnCta
                :label="$t('show.guest.btn')"
                @click="openAuthOverlay"
            />
            <p class="md:block pt-5">{{ $t('show.guest.sample') }}</p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'DocumentShowSignUpOverlay',
    methods: {
        openAuthOverlay() {
            this.$store.dispatch('ui/openRegistration');
        },
    },
    i18nOptions: {
        namespaces: ['document'],
    },
};
</script>

<style lang="scss" scoped>
.overlay-background {
    background-color: rgba(0, 0, 0, 0.8);
}
</style>
